//@vendor
const immutable = require('immutable');
const get = require('lodash/object/get');
const { handleActions, combineActions } = require('redux-actions');
//@actions
const { simpleActions } = require('../../actions/contractRetailLoan');
//@constants
const { EURO_TEXT } = require('constants/index');
const { WIZARD_THIRD_STEP, THIRD_STEP, FIRST_STEP, WIZARD_FIRST_STEP, SECOND_STEP } = require('constants/index');
const {
    contractEasyLoan: { PAYMENT_DAY_OTHER },
    retailLoanCommons: { TEXT_AREA_MAX_LENGTH, NO },
    STEPS,
    NEWSTEPS
} = require('../../loansConstants/index');

const setInitialState = () => immutable.fromJS({
    steps: [
        { valid: false },
        { valid: false },
        { valid: false, hasSignaturePattern: true }
    ],
    newSteps: [
        { valid: false },
        { valid: false },
        { valid: false },
        { valid: false, hasSignaturePattern: true }
    ],
    agree: false,
    agreeError: false,
    agreeThirdStep: false,
    timesTampCheckBox: null,
    agreeErrorThirdStep: false,
    arrangementFee: 0,
    arrangementPercentage: 0,
    currency: EURO_TEXT, //@hardcoded
    newEmail: '',
    error: false,
    beforeStep: 0,
    indCapson: '',
    installment: {
        amount: '',
        currency: EURO_TEXT,
        decimalsLength: 2
    },
    isAccountsInactive: false,
    isFetching: false,
    isFetchingProposition: false,
    isFetchingTae: false,
    isFetchingTotal: false,
    isFetchingDocuments: true,
    isFetchingDocumentsTermConditions: false,
    isFetchingFormalize: false,
    isFetchingAsnef: false,
    isFetchingZip: false,
    isNotAvailable: false,
    deliveryDate: '',
    documents: null,
    documentsTermConditions: null,
    paymentDaySelected: PAYMENT_DAY_OTHER,
    checkBillingAddress: true,
    personalData: {
        isSelected: true,
        locality: '',
        numberStreet: '',
        postalCode: '',
        province: 0,
        restOfAddress: '',
        streetName: '',
        typeOfRoads: 0,
    },
    otherAddress: {
        isSelected: false,
        locality: '',
        numberStreet: '',
        postalCode: '',
        province: 0,
        restOfAddress: '',
        streetName: '',
        typeOfRoads: 0,
    },
    billingAddress: {
        locality: '',
        numberStreet: '',
        postalCode: '',
        province: 0,
        restOfAddress: '',
        streetName: '',
        typeOfRoads: 0,
    },
    otherBillingAddressIsSelected: true,
    billingAddressError: false,
    proposition: {
        success: false
    },
    purpose: '',
    showInfoProduct: false,
    selectedAmount: 0,
    firstPayDate: '',
    success: false,
    monthlyPayment: 0,
    segmented: {},
    tae: 0,
    tin: 0,
    totalAmount: 0,
    visibleStep: 1,
    fetchProductsError: false,
    products: [],
    giftOption: NO,
    shippingInstructions: '',
    dedicationMessage: '',
    selectedTerm: '',
    termError: false,
    selectedAccount: '',
    selectedPickup: null,
    errorTotalAmount: '',
    errorDocuments: false,
    errorDocumentZip: false,
    errorDocumentsTermConditions: false,
    catalogIsLoaded: false,
    catalogItemId: 0,
    isFetchingAccount: false,
    destinationAccount: null,
    isFetchingSendPrecontractualInfo: false,
    sendPrecontractualInfoError: false,
    isUpdatingUserConsent: false,
    hasErrorUpdatingUser: false,
    hasUpdatedUserConsent: false,
    isFetchingPrintDocuments: false,
    acceptInterstitialConsentsValue: false,
    acceptInterstitialConsentsStatus: null,
    isFetchingStatusConsent: false,
    hasErrorConsentsStatus: false,
    errorConsentsStatusDescription: "",
    errorConsentsUpdateDescription: "",
    acceptAmazonConsentsStatus: null,
    isProductsFetchingSuccess: null,
    agreeIneCheckbox: false,
    isRetailEmailSent: false,
    isRetailEmailError: false,
    checkboxDisabled: true,
    sendSimpleEmail: true,
    changeStatusSteps: false
});

const processPropositionResponse = (state, response) => {
    return state.mergeDeep({
        proposition: {
            ...response,
            isFetching: false,
            success: true
        }
    });
};

const changeBillingAddress = (state, typeAddress) => {
    const personalData = {};
    const otherAddress = {};
    if (typeAddress === "personalData") {
        personalData.isSelected = true;
        otherAddress.isSelected = false;
    } else {
        personalData.isSelected = false;
        otherAddress.isSelected = true;
    }

    return state.mergeDeep({
        personalData,
        otherAddress,
    });
}

const updatePersonalData = (state, action) => {
    const { prop, personalData } = action.payload;

    if (prop === "billingAddress") {
        return state.mergeDeep({
            billingAddress: personalData,
            billingAddressError: false
        });
    } else {
        let personalDataInformation = {};
        let otherAddress = {};
        if (prop === "personalData") {
            personalDataInformation = personalData;
            personalDataInformation.isSelected = true;
            otherAddress.isSelected = false;
        } else {
            otherAddress = personalData;
            personalDataInformation.isSelected = false;
            otherAddress.isSelected = true;
        }

        return state.mergeDeep({
            personalData: personalDataInformation,
            otherAddress,
        });
    }

}

const initialize = (state, action) => {
    const products = get(action, 'payload.catalog.data.nodes', []);
    const segmented = get(action, 'payload.segmented');

    return state.mergeDeep({
        isFetching: false,
        products,
        segmented,
        catalogIsLoaded: true,
        isProductsFetchingSuccess: true
    });
}

const validateStepOne = (state, currentStep, beforeStep, steps) => {
    const hasSelectedTerm = !!state.get('selectedTerm');
    const visibleStep = hasSelectedTerm ? currentStep + 1 : currentStep;
    return state
        .setIn([steps, FIRST_STEP, 'valid'], hasSelectedTerm)
        .merge({
            visibleStep,
            termError: !hasSelectedTerm,
            beforeStep,
            isFetchingAsnef: false,
            errorAsnef: false
        });
};

const validateStepTwo = (state, currentStep, beforeStep, steps) => {
    const hasCheckBillingAddres = state.get('checkBillingAddress') ||
        (state.getIn(['otherAddres', 'typeOfRoads']) !== 0);
    let hasBillingAddress = state.get('otherBillingAddressIsSelected');
    if (!hasBillingAddress) {
        hasBillingAddress = state.getIn(['billingAddress', 'typeOfRoads']) !== 0;
    }
    const visibleStep = hasCheckBillingAddres && hasBillingAddress ? currentStep + 1 : currentStep;

    return state
        .setIn([steps, SECOND_STEP, 'valid'], true)
        .merge({
            visibleStep,
            beforeStep,
            errorAsnef: undefined,
            billingAddressError: !hasBillingAddress
        });
};
const validateStepFour = (state, currentStep, beforeStep, steps) => {
    let hasBillingAddress = state.get('otherBillingAddressIsSelected');
    if (!hasBillingAddress) {
        hasBillingAddress = state.getIn(['billingAddress', 'typeOfRoads']) !== 0;
    }
    return state
        .setIn([steps, THIRD_STEP, 'valid'], true)
        .merge({
            visibleStep: 4,
            beforeStep,
            errorAsnef: undefined,
            billingAddressError: !hasBillingAddress,
            checkboxDisabled: true,
            sendSimpleEmail: false,
            changeStatusSteps: false,
            agree: true,
            proposition: {
                success: true
            },
            agreeThirdStep:true
        });
};
const validateStepThree = (state, beforeStep, steps) => {
    const agreeThirdStep = state.get('agreeThirdStep');
    return state
        .setIn([steps, THIRD_STEP, 'valid'], agreeThirdStep)
        .merge({
            agreeErrorThirdStep: !agreeThirdStep,
            beforeStep
        });
};

const validateStep = (state, action) => {
    const currentStep = action.payload.currentStep;
    const newSteps = action.payload.newRetailFlowFeature;
    const hasSelectedTerm = !!state.get('selectedTerm');
    const beforeStep = hasSelectedTerm ? currentStep : state.get('beforeStep');
    const steps = newSteps ? NEWSTEPS : STEPS
    if (currentStep === WIZARD_FIRST_STEP) {
        return validateStepOne(state, currentStep, beforeStep, steps);
    } else if (currentStep === WIZARD_THIRD_STEP && steps === STEPS) {
        return validateStepThree(state, beforeStep, steps);
    }
    else if (currentStep === WIZARD_THIRD_STEP && steps === NEWSTEPS) {
        return validateStepFour(state, currentStep, beforeStep, steps);
    }
    else {
        return validateStepTwo(state, currentStep, beforeStep, steps);
    }
};

const contractRetailLoan = handleActions(
    {
        [simpleActions.retailLoanGetTae]: state =>
            state.merge({ isFetchingTae: true }),
        [simpleActions.retailLoanSetCatalogItemId]: (state, action) =>
            state.merge({
                purpose: action.payload.itemId,
                showInfoProduct: true
            }),
        [simpleActions.retailLoanSetTerm]: (state, action) =>
            state.merge({
                selectedTerm: action.payload.selectedTerm,
                termError: false
            }),
        [simpleActions.retailLoanSetPurpose]: (state, action) =>
            state.merge({
                purpose: action.payload.purpose
            }),
        [simpleActions.retailLoanSetShowProduct]: state =>
            state.merge({
                showInfoProduct: !state.get('showInfoProduct'),
            }),
        [simpleActions.retailLoanSetDeliveryDate]: (state, action) =>
            state.merge({ deliveryDate: action.payload.deliveryDate }),
        [simpleActions.retailLoanSetVisibleStep]: (state, action) =>
            state.merge({ visibleStep: action.payload.visibleStep }),
        [simpleActions.retailLoanValidateStep]: (state, action) =>
            validateStep(state, action),
        [simpleActions.retailLoanProducts]: state =>
            state.merge({ isFetching: true }),
        [simpleActions.retailLoanProductsSuccess]: (state, action) =>
            initialize(state, action),
        [simpleActions.retailLoanProductsError]: state =>
            state.merge({
                isFetching: false,
                fetchProductsError: true,
                products: []
            }),
        [simpleActions.retailLoanDestinationAccount]: state =>
            state.merge({
                isFetchingAccount: true
            }),
        [simpleActions.retailLoanDestinationAccountSuccess]: (state, action) => {
            const providers = get(action, 'payload.response.providers', []);
            const id = get(action, 'payload.response.provider');
            const provider = providers.find(item => item.name === id);

            return state.merge({
                isFetchingAccount: false,
                destinationAccount: get(provider, 'account', '')
            });
        },
        [simpleActions.retailLoanDestinationAccountError]: state =>
            state.merge({
                error: true,
                isFetchingAccount: false,
                destinationAccount: null
            }),
        [simpleActions.retailLoanResetState]: state =>
            state.merge(setInitialState()),
        [simpleActions.retailLoanValidateAgreeCheckbox]: state =>
            state.merge({
                showInfoProduct: !state.get('agree'),
                agreeError: !state.get('agree')
            }),
        [simpleActions.retailLoanValidateAgreeCheckboxModal]: state =>
            state.merge({
                agreeError: !state.get('agree')
            }),
        [simpleActions.retailLoanResetDocumentAndAgreeCheckbox]: state =>
            state.merge({
                agree: false,
                agreeError: false
            }),
        [simpleActions.retailLoanResetErrorsStatus]: state =>
            state.merge({
                hasErrorUpdatingUser: false,
                hasErrorConsentsStatus: false
            }),
        [simpleActions.retailLoanSetAgree]: state =>
            state.merge({
                agree: !state.get('agree'),
                agreeError: false
            }),
        [simpleActions.retailLoanSetInterstitialCheck]: state =>
            state.merge({
                acceptInterstitialConsentsValue: !state.get('acceptInterstitialConsentsValue'),
            }),
        [simpleActions.retailLoanResetAgreeCheckboxModal]: state =>
            state.merge({
                acceptInterstitialConsentsValue: false,
            }),
        [simpleActions.retailLoanConsents]: state =>
            state.merge({
                isFetchingStatusConsent: true,
                hasErrorConsentsStatus: false
            }),
        [simpleActions.retailLoanConsentsSuccess]: (state, action) => {
            const statusConsents = action.payload.status;
            return state.merge({
                isFetchingStatusConsent: false,
                hasErrorConsentsStatus: false,
                acceptInterstitialConsentsValue: statusConsents
            });
        },
        [simpleActions.retailLoanConsentsError]: (state, action) =>
            state.merge({
                isFetchingStatusConsent: false,
                hasErrorConsentsStatus: true,
                errorConsentsStatusDescription: action.payload.error
            }),
        [simpleActions.retailLoanAmazonConsentsSuccess]: (state, action) => {
            return state.merge({
                acceptAmazonConsentsStatus: action.payload.status
            });
        },
        [simpleActions.retailLoanConsentUpdate]: state =>
            state.merge({
                hasUpdatedUserConsent: false,
                isUpdatingUserConsent: true,
                hasErrorUpdatingUser: false
            }),
        [simpleActions.retailLoanConsentUpdateSuccess]: (state, action) => {
            const interstitialConsentsStatus = action.payload.interstitialStatus;
            const amazonConsentsStatus = action.payload.amazonStatus;
            return state.mergeDeep({
                isUpdatingUserConsent: false,
                hasUpdatedUserConsent: true,
            }, interstitialConsentsStatus && {
                acceptInterstitialConsentsStatus: interstitialConsentsStatus,
            }, amazonConsentsStatus && {
                acceptAmazonConsentsStatus: amazonConsentsStatus
            });
        },
        [simpleActions.retailLoanConsentUpdateError]: (state, action) =>
            state.merge({
                isUpdatingUserConsent: false,
                hasErrorUpdatingUser: true,
                errorConsentsUpdateDescription: action.payload.error,
            }),
        [simpleActions.retailLoanConsents]: state =>
            state.merge({
                isFetchingStatusConsent: true,
                hasUpdatedUserConsent: false
            }),
        [simpleActions.retailLoanConsentsSuccess]: (state, action) => {
            const statusConsents = action.payload.status;
            return state.merge({
                isFetchingStatusConsent: false,
                acceptInterstitialConsentsStatus: statusConsents
            });
        },
        [simpleActions.retailLoanResetAgreeThirdStep]: state =>
            state.merge({
                agreeThirdStep: false,
                agreeErrorThirdStep: false,
                documents: null,
                isFetchingDocuments: true
            }),
        [simpleActions.retailLoanSetAgreeThirdStep]: state =>
            state.merge({
                agreeThirdStep: !state.get('agreeThirdStep'),
                timesTampCheckBox: new Date().getTime(),
                agreeErrorThirdStep: false
            }),
        [simpleActions.retailLoanSetGift]: (state, action) =>
            state.merge({ giftOption: action.payload.giftOption }),
        [simpleActions.retailLoanSetInstructions]: (state, action) => {
            const instructions = action.payload.instructions || '';
            return state.merge({ shippingInstructions: instructions.substring(0, TEXT_AREA_MAX_LENGTH) });
        },
        [simpleActions.retailLoanSetDedication]: (state, action) => {
            const dedication = action.payload.dedication || '';
            return state.merge({ dedicationMessage: dedication.substring(0, TEXT_AREA_MAX_LENGTH) });
        },
        [simpleActions.retailLoanGetTaeSuccess]: (state, action) =>
            state.mergeDeep({
                isFetchingTae: false,
                tae: action.payload.tae,
                indCapson: action.payload.indCapson,
                installment: {
                    amount: get(action, 'payload.installment')
                },
                changeStatusSteps: true,
                visibleStep: 1,
                changeStatusSteps: true,
                fileRetailLoanINEDocument: null,
                fileRetailLoanINEDocumentId: null,
                agreeIneCheckbox: false,
                scrollDown: false,
                sendSimpleEmail: true
            }),
        [simpleActions.retailLoanGetTaeError]: state =>
            state.mergeDeep({
                isFetchingTae: false,
                tae: 0,
                installment: { amount: 0 }
            }),
        [simpleActions.retailLoanGetTotalImport]: state =>
            state.merge({
                isFetchingTotal: true
            }),
        [simpleActions.retailLoanGetTotalImportSuccess]: (state, action) =>
            state.merge({
                isFetchingTotal: false,
                totalAmount: action.payload.totalAmount
            }),
        [simpleActions.retailLoanGetTotalImportError]: (state, action) =>
            state.merge({
                isFetchingTotal: false,
                errorTotalAmount: action.payload.error
            }),
        [simpleActions.retailLoanUpdatePersonalData]: (state, action) =>
            updatePersonalData(state, action),
        [simpleActions.retailLoanFormalize]: state =>
            state.merge({ isFetchingFormalize: true }),
        [simpleActions.retailLoanFormalizeSuccess]: state =>
            state.merge({ isFetchingFormalize: false, success: true }),
        [simpleActions.retailLoanFormalizeError]: state =>
            state.merge({ isFetchingFormalize: false, error: true }),
        [simpleActions.retailLoanChangeEmail]: (state, action) =>
            state.merge({ newEmail: action.payload.newEmail || '' }),
        [simpleActions.retailLoanChangeBillingAddress]: (state, action) =>
            changeBillingAddress(state, action.payload.typeAddress),
        [simpleActions.retailLoanSetAccount]: (state, action) =>
            state.merge({ selectedAccount: action.payload.accountId }),
        [simpleActions.retailLoanPropositionInfo]: state =>
            state.merge({ isFetchingProposition: true })
                 .merge({proposition: { success: false, isFetching: true }}),
        [simpleActions.retailLoanPropositionInfoSuccess]: (state, action) =>
            processPropositionResponse(state, action.payload.response),
        [simpleActions.retailLoanPropositionInfoError]: state =>
            state.merge({ isFetchingProposition: false }),
        [simpleActions.retailLoanResetCatalogItem]: state =>
            state.mergeDeep({
                catalogIsLoaded: false,
                products: []
            }),
        [simpleActions.retailLoanResetPurpose]: state =>
            state.mergeDeep({
                purpose: '',
                showInfoProduct: false
            }),
        [simpleActions.retailLoanAsnefError]: state =>
            state.merge({ error: true }),
        [simpleActions.retailLoanAsnefFailure]: state =>
            state.merge({
                isFetchingAsnef: false,
                errorAsnef: true
            }),
        [simpleActions.retailLoanAsnef]: state =>
            state.merge({
                isFetchingAsnef: true,
                errorAsnef: false
            }),
        [simpleActions.retailLoanAsnefSuccess]: (state, action) =>
            validateStep(state, action),
        [simpleActions.retailLoanHiringDocuments]: state =>
            state.merge({
                isFetchingDocuments: true,
                errorDocuments: false
            }),
        [simpleActions.retailLoanHiringDocumentsSuccess]: (state, action) =>
            state.merge({
                isFetchingDocuments: false,
                documents: action.payload.documents,
                errorDocuments: false
            }),
        [simpleActions.retailLoanHiringDocumentsError]: state =>
            state.merge({
                isFetchingDocuments: false,
                errorDocuments: true
            }),
        [simpleActions.retailLoanDownloadZipDocument]: state =>
            state.merge({
                isFetchingZip: true,
                errorDocumentZip: false
            }),
        [simpleActions.retailLoanDownloadZipDocumentSuccess]: state =>
            state.merge({
                isFetchingZip: false,
                errorDocumentZip: false
            }),
        [simpleActions.retailLoanDownloadZipDocumentError]: state =>
            state.merge({
                isFetchingZip: false,
                errorDocumentZip: true
            }),
        [simpleActions.retailLoanSetAccountsInactive]: state =>
            state.merge({
                isAccountsInactive: true
            }),
        [simpleActions.retailLoanTermCondition]: state =>
            state.merge({
                isFetchingDocumentsTermConditions: true,
                errorDocumentsTermConditions: false
            }),
        [simpleActions.retailLoanTermConditionSuccess]: (state, action) =>
            state.merge({
                isFetchingDocumentsTermConditions: false,
                documentsTermConditions: action.payload.documentsTermConditions,
                errorDocumentsTermConditions: false
            }),
        [simpleActions.retailLoanTermConditionError]: state =>
            state.merge({
                isFetchingDocumentsTermConditions: false,
                errorDocumentsTermConditions: true
            }),
        [simpleActions.retailLoanNotAvailable]: state =>
            state.merge({
                isNotAvailable: true
            }),
        [simpleActions.retailLoanSetPickup]: (state, action) =>
            state.merge({
                selectedPickup: action.payload.pickup
            }),
        [simpleActions.retailLoanChangeDeliveryAddressValue]: state =>
            state.mergeDeep({
                otherBillingAddressIsSelected: !state.get('otherBillingAddressIsSelected'),
                billingAddressError: false
            }),
        [simpleActions.retailLoanSendPrecontractualInfoRequest]: state =>
            state.merge({
                isFetchingSendPrecontractualInfo: true
            }),
        [simpleActions.retailLoanSendPrecontractualInfoSuccess]: state =>
            state.merge({
                isFetchingSendPrecontractualInfo: false,
                sendPrecontractualInfoError: false,
            }),
        [simpleActions.retailLoanSendPrecontractualInfoFailure]: (state, action) =>
            state.merge({
                isFetchingSendPrecontractualInfo: false,
                sendPrecontractualInfoError: action.payload.error,
            }),
        [simpleActions.contractRetailLoanInitSuccess]: (state, action) =>
            state.merge({
                retailInitOperationProcessId: action.payload.retailInitOperationProcessId,
            })
        ,
        [simpleActions.retailLoanCommercialProductsSuccess]: (state, action) => {
            return state.merge({
                commercialProducts: action.payload,
            })
        },
        [simpleActions.contractRetailLoanInitPolicySuccess]: (state, action) =>
            state.merge({
                retailInitPolicyOperationProcessId: action.payload.retailInitPolicyOperationProcessId,
            }),
        [simpleActions.contractRetailLoanInitError]: state =>
            state.merge({
                isEasyLoanEmailInitError: true,
                isEasyLoanEmailInitSuccess: false
            }),
        [simpleActions.getRetailLoanIneDocumentSuccess]: (state, action) => state.merge({
            fileRetailLoanINEDocument: `data:application/pdf;base64,${action.payload.base64}`,
            fileRetailLoanINEDocumentId: action.payload.documentId,
        }),
        [simpleActions.getRetailLoanIneDocumentError]: (state, action) =>
            state.merge({
                error: true,
            }),
        [simpleActions.getRetailLoanPolicyDocumentSuccess]: (state, action) =>
            state.merge({
                fileRetailLoanPolicyDocument: `data:application/pdf;base64,${action.payload.base64}`,
                fileRetailLoanPolicyDocumentId: action.payload.documentId,
            })
        ,
        [simpleActions.getRetailLoanPolicyDocumentError]: (state, action) => state.merge({
            error: true,
        }),
        [simpleActions.contractRetailLoanReadDocument]: (state) =>
            state.merge({
                scrollDown: true,
                agreeThirdStep: true,
                agreeError: false,
                checkboxDisabled: false,
                isFetchingDocuments: false
            }),
        [simpleActions.contractRetailLoanCheckBoxCheckedDocument]: (state, action) =>
            state.merge({
                agreeIneCheckbox: !action.payload,
                isFetchingDocuments: false
            }),
        [simpleActions.retailLoanDownloadPrintDocument]: state =>
            state.set('isFetchingPrintDocuments', true),
        [combineActions(
            simpleActions.retailLoanDownloadPrintDocumentError,
            simpleActions.retailLoanDownloadPrintDocumentSuccess
        )]: state =>
                state.set('isFetchingPrintDocuments', false),
        [simpleActions.contractRetalEmailSuccess]: state =>
            state.merge({
                isRetailEmailSent: true,
                isRetailEmailError: false
            }),
        [simpleActions.contractRetailEmailError]: state =>
            state.merge({
                isRetailEmailSent: false,
                isRetailEmailError: true
            }),
    },
    setInitialState()
);

module.exports = contractRetailLoan;
module.exports.setInitialState = setInitialState;
